import { createSlice } from '@reduxjs/toolkit';
import { TagState } from '../../types/Tag';

const initialState: TagState[] = [];

const communityTagSlice = createSlice({
  name: 'communityTags',
  initialState,
  reducers: {
    addCommunityTag: (state, action): void => {
      const newState = [...state, action.payload];
      newState.sort((a, b): number => a.name.localeCompare(b.name));
      state.splice(0, state.length, ...newState);
    },
    removeCommunityTag: (state, action): void => {
      const index = state.findIndex((tag): boolean => tag.tagId === action.payload);
      if (index !== -1) state.splice(index, 1);
    },
    setCommunityTags: (state, action): void => {
      state.splice(0, state.length, ...action.payload);
    },
  },
});

export const { addCommunityTag, removeCommunityTag, setCommunityTags } = communityTagSlice.actions;
export default communityTagSlice.reducer;
